<template>
  <div v-show="show">
    <div class="ivu-modal-mask"></div>
    <div class="ivu-modal-wrap">
      <div class="ivu-modal" :style="styles">
        <div class="ivu-modal-content">
          <div class="ivu-modal-body">
            <slot name="body"></slot>
          </div>
          <div class="ivu-modal-footer" v-if="isFooter">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 异步请求url
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: "600"
    },
    isFooter:{
      type:Boolean,
      default:true
    },
    styles: {
      type: Object,
      default: {width:'730px'}
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped>
.ivu-modal-mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(55, 55, 55, 0.6);
  height: 100%;
  z-index: 1052;
}
.ivu-modal-wrap {
  position: fixed;
  overflow: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
 z-index: 9999;
  -webkit-overflow-scrolling: touch;
  outline: 0;
}
.ivu-modal {
  width: auto;
  margin: 0 auto;
  position: relative;
  outline: 0;
  top: 100px;
}
.ivu-modal-content {
  position: relative;
  background-color: #fff;
  border: 0;
  border-radius: 6px;
  background-clip: padding-box;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.ivu-modal-body {
  padding: 16px;
  font-size: 12px;
  line-height: 1.5;
}
.ivu-modal-footer {
  border-top: 1px solid #e8eaec;
  padding: 12px 18px;
  text-align: right;
}
</style>





// WEBPACK FOOTER //
// src/components/Public/dataModal/dataModal.vue